import { createAuthedApi } from './authedApi'
import type { StaffSession } from '../types'

/**
 * Staff/owner-console realm: its OWN client + session store, separate from the customer one,
 * so a customer token can never ride a staff call, nor vice-versa (token separation, §9 /
 * D-027). Silent refresh via the rotating httpOnly `staff_refresh` cookie keeps the live
 * board running across access-token expiry. See createAuthedApi for the full session model.
 */
export const {
  api: ownerApi,
  getSession: getStaffSession,
  setSession: setStaffSession,
  clearSession: clearStaffSession,
  hasSessionHint: hasStaffSessionHint,
  setUnauthorizedHandler: setOwnerUnauthorizedHandler,
  bootstrapSession: bootstrapStaffSession,
  logoutServerSession: logoutStaffServerSession,
} = createAuthedApi<StaffSession>({
  hintKey: 'dukaano.staff.session',
  legacyKey: 'dukaano.staff',
  refreshPath: '/api/auth/refresh',
  logoutPath: '/api/auth/logout',
})
